import * as z from "zod";

export const getFulfillForTeams = {
  name: "getFulfillForTeams" as const,
  input: z.object({ fulfillmentServiceTeamId: z.string() }),
  output: z.object({
    teams: z.array(z.object({ _id: z.string(), name: z.string() })),
  }),
};
